// src/App.js
import React from 'react';
import './index.css';
import CampsiteMapListView from './components/CampsiteMapListView';

export default function App() {
  return (
    <div className="min-h-screen bg-gray-50 m-0 p-0">
      <CampsiteMapListView />
    </div>
  );
}